import FiltersDisplayCondition from './FiltersDisplayCondition';
import FiltersDisplayRelatedConditionsHeading from './FiltersDisplayRelatedConditionsHeading';
import { isLogicGroup, LogicGroupNames } from '../../filterQueryFormat/logic/LogicGroup';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FiltersDisplayRelatedConditions = props => {
  const {
    logicGroup,
    conditionPath
  } = props;
  const logicGroupConditionsSeq = logicGroup.conditions.entrySeq();
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(FiltersDisplayRelatedConditionsHeading, {
      conditionPath: conditionPath,
      logicGroup: logicGroup
    }), /*#__PURE__*/_jsx(View, {
      marginInlineStart: "500",
      children: logicGroupConditionsSeq.map(([key, condition], index) => {
        const currConditionPath = conditionPath.push(key);
        if (isLogicGroup(condition)) {
          return (
            /*#__PURE__*/
            /* eslint-disable-next-line react/jsx-key */
            _jsx(FiltersDisplayRelatedConditions, {
              conditionPath: currConditionPath,
              logicGroup: condition,
              parentLogicGroupOperator: LogicGroupNames.AND
            })
          );
        }
        return /*#__PURE__*/_jsx(FiltersDisplayCondition, {
          condition: condition,
          filterFamily: logicGroup.filterFamily,
          parentLogicGroup: logicGroup,
          isFirst: true
        }, `${index}-${key}`);
      })
    }), logicGroup.errors.map((error, index) => /*#__PURE__*/_jsx(Text, {
      display: "block",
      marginBlockStart: "200",
      typography: "heading-25",
      use: "error",
      children: error.message
    }, `${conditionPath.join('_')}_error_${index}`))]
  });
};
export default FiltersDisplayRelatedConditions;